import { CommunityStatus } from '../enums';

export const COMMUNITY_TITLE_MAX_CHARS = 120;
export const COMMUNITY_ABOUT_MAX_CHARS = 5000;
export const COMMUNITY_RULES_MAX_CHARS = 10000;
export const COMMUNITY_SLUG_MAX_CHARS = 80;
export const COMMUNITY_JOIN_INTAKE_ANSWER_MAX_CHARS = 1000;
export const COMMUNITY_MEMBER_FIELD_ANSWER_MAX_CHARS = 1000;
export const COMMUNITY_ADULT_CONTENT_MIN_AGE = 18;
export const COMMUNITY_ADULT_CONTENT_MAX_AGE = 21;

export interface Community {
  id: string;
  creatorId: string;
  slug: string | null;
  title: string;
  about: string | null;
  rules: string | null;
  coverUrl: string | null;
  coverKey: string | null;
  status: CommunityStatus;
  publishedAt: Date | null;
  publishedById: string | null;
  createdAt: Date;
  updatedAt: Date;
}
